export const BANNER_VERSION = ['default', 'compact', 'serviceApp'] as const
export const IMAGE_URL =
  'https://assets.everphone.app/device-definition/HP_Color_Laser_150a_Drucker_(4ZB94A-B19).png'
